import { getContentSplitTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

/**
 *  When user clicks on a shortcode to edit it
 */
const editContentSplitConfig = (editor, shortcodeWrapper) => {
  let currentData = null;

  const splitConfigWindow = editor.windowManager.openUrl({
    title: "Content Split",
    url: "/content-split-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("content-split-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateData") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    splitConfigWindow.sendMessage({
      type: "sendData",
      data: shortcodeWrapper.getAttribute("content-split-data"),
    });
  };
};

/**
 * when user adds shortcode initially
 */
const contentSplitConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Content Split",
    url: "/content-split-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      // This is a string for now. We have to convert it to DOM element to be able to set data attribute.
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getContentSplitTemplate(), "content-split");
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute("content-split-data", currentData);

      // Since we have to pass a string representation of DOM element, pass outerHTML of shortcodeWrapper
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { contentSplitConfig, editContentSplitConfig };
